import { render } from "./BaseNotificacao.vue?vue&type=template&id=947dcb20&scoped=true"
import script from "./BaseNotificacao.vue?vue&type=script&lang=js"
export * from "./BaseNotificacao.vue?vue&type=script&lang=js"

import "./BaseNotificacao.vue?vue&type=style&index=0&id=947dcb20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947dcb20"]])

export default __exports__